import React from 'react';
import styled, { css } from 'styled-components';
import { CHOICE_LIMIT_ZERO } from '../../../constants';
import PillSelectBox from '../PillSelectBox';
import { LimitTooltip } from '../TooltipModals';

const Container = styled.div`
  width: 100px;
  display: inline-block;

  & > label {
    color: #797979;
    letter-spacing: -0.2px;
  }

  ${props => {
    if (props.variant === 'OptionsField') {
      return css`
        margin-right: 10px;

        & > label {
          display: inline-block;
          padding-bottom: 20px;
        }
      `;
    }
  }}
`;

function LimitSelect(props) {
  const options = [];

  const handleChange = e => {
    const value = parseInt(e.target.value, 10);

    props.onChange({ ...e, target: { ...e.target, value: value } });
  };

  // default max 10
  for (let i = 1; i <= 10; i++) {
    options.push(
      <option
        key={`limit-option-${props.id}-${i}`}
        className="select-box__option"
        value={i}
      >
        {i}
      </option>
    );
  }

  return (
    <Container className={props.className} variant={props.variant}>
      <label
        htmlFor={props.id}
        style={{ display: props.hideLabel ? 'none' : '' }}
      >
        Limit
      </label>
      {props.hideLabel ? null : <LimitTooltip />}
      <PillSelectBox
        id={props.id}
        key={`limit-${props.id}`}
        value={props.value || '0'}
        variant={props.variant}
        onChange={handleChange}
      >
        <option
          key={`limit-option-${props.id}-default`}
          className="select-box__option"
          default
          value="0"
        >
          {props.placeholder || CHOICE_LIMIT_ZERO}
        </option>
        {options}
      </PillSelectBox>
    </Container>
  );
}

export default LimitSelect;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/LimitSelect/index.jsx